module.exports = __webpack_public_path__ + "img/process.e840c588.png";